import React, { Fragment } from 'react';

import MonitoredDocumentVersionListItem from './MonitoredDocumentVersionListItem.component';
import PropTypes from 'prop-types';
import ResultsList from '../../../ResultsList';

const MonitoredDocumentVersionList = ({ monitoredDocumentVersions = [], backLink, ...remain }) => {
    return (
        <Fragment>
            <ResultsList {...remain}>
                {monitoredDocumentVersions.length
                    ? monitoredDocumentVersions.map(monitoredDocumentVersion => (
                          <MonitoredDocumentVersionListItem
                              key={monitoredDocumentVersion.s3Version}
                              backLink={backLink}
                              {...monitoredDocumentVersion}
                          />
                      ))
                    : null}
            </ResultsList>
        </Fragment>
    );
};

MonitoredDocumentVersionList.propTypes = {
    backLink: PropTypes.string,
    monitoredDocumentVersions: PropTypes.arrayOf(
        PropTypes.shape({
            s3Version: PropTypes.string.isRequired,
        })
    ),
};

export default MonitoredDocumentVersionList;
